<template>
  <v-text-field
    v-bind="$attrs"
    color="primary"
    density="compact"
    variant="outlined"
    label="Pesquisar"
    rounded
    single-line
    clearable
    hide-details
    prepend-inner-icon="$pesquisar"
    :style="{ minWidth: width, maxWidth: width }"
    @focus="onFocus"
    @keyup.enter="onFocus"
    @keyup.esc="$emit('click:clear')"
  ></v-text-field>
</template>
<script setup>

const props = defineProps({
  select: {
    type: Boolean,
    default: false,
  },

  width: {
    type: String,
    default: '250px',
  },
});

const onFocus = (event) => {
  if (props.select == true) {
    setTimeout(() => {
      event.target.select();
    }, 0);
  }
};
</script>

<style scoped>
</style>
